import script from "./EmailInteractionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailInteractionPanel.vue?vue&type=script&setup=true&lang=ts"

import "./EmailInteractionPanel.vue?vue&type=style&index=0&id=0d6ae356&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6ae356"]])

export default __exports__